// extracted by mini-css-extract-plugin
export default {"user-camera-drop-zones-wrapper":"user-camera-drop-zones-wrapper__OBcFF"};